import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import Drawer from "./components/Drawer";

import './DrawerContainer.css';

@inject("appStore")
@observer
class DrawerContainer extends Component {
    render() {
        return (
            <div className="DrawerContainer">
                <Drawer/>
            </div>
            );
        }
}

export default DrawerContainer;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/index.js